import { Analytics, AWSKinesisProvider } from '@aws-amplify/analytics';
import { KinesisAnalyticsEvent } from '@aws-amplify/analytics/lib-esm/types';

// Pinpoint-era name, deliberately unchanged: this is the stream Firehose already drains.
const STREAM_NAME = 'atozidentityapp-pinpoint';

let configured = false;

export function configureTransport(): void {
    if (configured) {
        return;
    }
    configured = true;

    Analytics.addPluggable(new AWSKinesisProvider());
    Analytics.configure({ AWSKinesis: { region: 'us-west-2' } });
}

export function resetTransport(): void {
    configured = false;
}

export function sendEnvelope(payload: string, immediate: boolean): void {
    const event: Omit<KinesisAnalyticsEvent, 'partitionKey'> = { data: payload, streamName: STREAM_NAME, immediate };

    Analytics.record(event as KinesisAnalyticsEvent, 'AWSKinesis').catch(() => undefined);
}
